<template>
  <div>
    <v-card
      class="mb-5"
    >
        <v-card-text>
        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete
             v-model="OfficeID"
            item-text="OfficeDescription"
            item-value="OfficeID"
            :items="office"
            hide-details
            color="header"
            label="Filter by Office"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
            v-model="UserID"
            item-text="name"
            item-value="UserID"
            :items="users"
            hide-details
            color="header"
            label="Filter by End User"
          >
          </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu
              dense
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="DateRange"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  dense
                  v-model="DateRange"
                  label="Date Range"
                  color="header"
                  v-bind="attrs"
                  v-on="on"
                  class="mt-5"
                  hide-details
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker
                v-model="DateRange"
                no-title
                scrollable
                range
                color="header"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="header" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn
                  class="white--text"
                  color="header"
                  @click="$refs.menu1.save(DateRange)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        </v-card-text>
    </v-card>
    
    <v-data-table
      :headers="headers"
      :items="requestList"
      :options.sync="options"
      :server-items-length="totalCount"
      :loading="loading"
      :footer-props="footerProps"
      class="elevation-1 pt-2"
    >
      <template v-slot:top>
        <v-tabs color="green darken-2" class="my-1">
          <v-tab @click="tab = 1">For Approval</v-tab>
          <v-tab @click="tab = 2">Approved</v-tab>
          <v-tab @click="tab = 3">Pending</v-tab>
        </v-tabs>
        <v-toolbar flat class="mx-1">
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            placeholder="Search for Request Code"
            color="green darken-2"
            single-line
            class="pa-0"
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            RequestCode: { title: 'Request Code' },
            RequestType: { title: 'Request Type' },
            Office: { title: 'Office' },
            RequestedBy: { title: 'Requested By' },
            DateCreated: { title: 'Date Created' },
            }"
          csv-title="Requests">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
        </v-toolbar>
      </template>
      <template v-slot:[`item.RequestCode`]="{ item }">
          <span class="text-no-wrap">{{ item.RequestCode }}</span>
        </template>
        <template v-slot:[`item.DateCreated`]="{ item }">
          {{ formatDateTime(item.DateCreated) }}
        </template>
        <template v-slot:[`item.Actions`]="{ item }">
          <span class="text-no-wrap">
          <v-btn
            color="green darken-2"
            dark
            outlined
            elevation="2"
            v-if="tab == 1 || tab == 3"
            small
            class="mr-2"
            @click="approveItem(item)"
          >
            Approve
          </v-btn>
          <v-btn
            color="red darken-2"
            dark
            outlined
            elevation="2"
            class="mr-2"
            small
            v-if="tab == 1"
            @click="pendingItem(item)"
          >
            Pending
          </v-btn>
          <v-btn
            color="blue darken-2"
            dark
            outlined
            elevation="2"
            small
            @click="viewPPMP(item)"
          >
            View
          </v-btn>
          </span>
        </template>
    </v-data-table>
    <v-dialog v-model="pendingDialog" max-width="550px">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <v-form @submit.prevent ref="formRef">
          <div class="mx-6">
            Are you sure you want to pending this Request?
            <br /><br />
            <div>Request #: <strong>{{confirmData.RequestCode}}</strong></div>
            <div>Request Type: <strong>{{confirmData.RequestType}}</strong></div>
            <v-row class="mt-2">
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    color="green"
                    dense
                    v-model="remarks"
                    :rules="[formRules.required]"
                    label="Remarks"
                    counter
                    outlined
                    maxlength="500"
                  ></v-textarea>
                </v-col>
              </v-row>
          </div>
          <v-card-actions class="pt-5 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-2" outlined @click="pendingDialog = false">Cancel</v-btn>
            <v-btn color="red darken-2 white--text" @click="confirmPending()"><v-icon class="mr-1">mdi-check-circle</v-icon>PENDING</v-btn>
          </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    <v-dialog v-model="approveDialog" max-width="550px">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>
          <div class="mx-6">
            Are you sure you want to approve this Request?
            <br /><br />
            <div>Request #: <strong>{{confirmData.RequestCode}}</strong></div>
            <div>Request Type: <strong>{{confirmData.RequestType}}</strong></div>
          </div>
          <v-card-actions class="pt-5 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-2" outlined @click="approveDialog = false">Cancel</v-btn>
            <v-btn color="header darken-2 white--text" @click="confirmApprove()"><v-icon class="mr-1">mdi-check-circle</v-icon>APPROVE</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <ViewRequest :requestData="requestItem" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    ViewRequest: () => import("./ViewRequest"),
  },
  data: () => ({
    OfficeID: 0,
    UserID: 0,
    office : [],
    users : [],
    searchText: "",
    searchTimeout: null,
    tab: 1,
    remarks: null,
    pendingDialog: false,
    approveDialog: false,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    loading: true,
    options: {},
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Saved!",
      message: "",
      top: 10,
    },
    isLoading: false,
    requestList: [],
    requestItem: [],
    confirmData: {},
    headers: [
       { text: 'Request Code', value: 'RequestCode', sortable: false, align: 'start', class: "green darken-2 white--text text-caption font-weight-bold" },
        {
          text: 'RequestType',
          align: 'start',
          sortable: false,
          value: 'RequestType',
          class: "green darken-2 white--text text-caption font-weight-bold",
        },
        { text: 'Office', value: 'Office', align: "start", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Requested By', value: 'RequestedBy', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Date Created', value: 'DateCreated', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      {
        text: "Actions",
        value: "Actions",
        sortable: false,
        align: "center",
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
    ],
    DateRange: null,
    menu1: false,
    itemListForCSV: [],
    loadingCSV: true,
  }),
  watch: {
    searchText: function () {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.initialize();
      }, 600);
    },
    OfficeID: function () {
        this.initialize();
    },
    UserID: function () {
        this.initialize();
    },
    DateRange: function () {
        this.initialize();
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    tab: {
      handler() {
        this.requestList = [];
        this.initialize();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.eventHub.$on("closeViewRequest", () => {
      this.initialize();
      this.requestItem = {};
    });
    this.getUserAndOffice();
  },
  beforeDestroy() {
    this.eventHub.$off("closeViewRequest");
  },
  methods: {
    getUserAndOffice() {
      this.axiosCall(
              '/getOfficeAndOthersForCreateUpdate',
              'GET'
          )
          .then((res) => {
              this.users = this.prepend({UserID: 0, name: 'All'},res.data.data.users);
              this.office = this.prepend({OfficeID: 0, OfficeDescription: 'All'},res.data.data.office);
          })
		},
    viewPPMP(item) {
      this.requestItem = item;
    },
    confirmPending() {
      if (this.$refs.formRef.validate()) {
        let data = new FormData();
        data.append("Remarks", this.remarks);
        data.append("RequestID", this.confirmData.RequestID);
        this.axiosCall("/request/pending", "POST", data).then(
          (res) => {
            console.log(res);
            this.pendingDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "Request was successfully set to pending!";
            this.fadeAwayMessage.header = "System Message";
            this.initialize();
          }
        );
      }
    },
    confirmApprove() {
      let data = new FormData();
      data.append("RequestID", this.confirmData.RequestID);
      this.axiosCall("/request/approve", "POST", data).then((res) => {
        console.log(res);
        this.approveDialog = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "success";
        this.fadeAwayMessage.message = "Request was successfully approved!";
        this.fadeAwayMessage.header = "System Message";
        this.initialize();
      });
    },
    print(data) {
      window.open(this.apiUrl + "/request/report/" + data.RequestCode);
    },
    pendingItem(data) {
      this.confirmData = data;
      this.pendingDialog = true;
    },
    approveItem(data) {
      this.confirmData = data;
      this.approveDialog = true;
    },
    initialize() {
      this.requestList = [];
      this.loading = true;
      this.loadingCSV = true;
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("tab", this.tab);
      data.append("searchText", this.searchText);
      data.append("OfficeID", this.OfficeID);
      data.append("UserID", this.UserID);
      this.axiosCall("/request/approval", "POST", data).then((res) => {
        this.loading = false;
        this.loadingCSV = false;
        this.requestList = res.data.data.result;
        this.itemListForCSV = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
      });
    },
    save() {
      if (this.$refs.formRef.validate() && !this.amountErr) {
        this.isLoading = true;
        let data = new FormData();
        data.append("Amount", this.formData.Amount);
        data.append("isDBM", this.formData.isDBM);
        data.append("BudgetID", this.formData.BudgetID);
        data.append("PPMPDescription", this.formData.PPMPDescription);
        this.axiosCall("/PPMP/add", "POST", data).then((res) => {
          this.isLoading = false;
          if (res.data.status) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "PPMP Successfully Added!";
            this.fadeAwayMessage.header = "System Message";
            this.$refs.formRef.reset();
            this.addPPMPDialog = false;
            this.initialize();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = "Something went wrong try again!";
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
  },
};
</script>   